import React, { Component } from 'react';
// import logo from './logo.svg';
import './App.css';

// import CssBaseline from 'material-ui/CssBaseline';
// import { withStyles } from 'material-ui/styles';
// import Button from 'material-ui/Button';
// import Grid from 'material-ui/Grid';
// import AppBar from 'material-ui/AppBar';
// import Toolbar from 'material-ui/Toolbar';
// import Typography from 'material-ui/Typography';
// import Paper from 'material-ui/Paper';
import Home from './screens/Home';
import Edit from './screens/Edit';

import { Route } from 'react-router-dom';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedMessage: {}
    };
  }
  selectMessage(msg) {
    this.setState({ selectedMessage: msg });
  }
  render() {
    return (
      <div className="App">
        {/*<AppBar position="static" color="default">
          <Toolbar>
            <Typography variant="title" color="inherit">
              Title
            </Typography>
          </Toolbar>
        </AppBar>
        <Grid
          container={true}
          className={classes.root}
          alignItems={'stretch'}
          spacing={0}
        >
          <Grid item xs={3} className={classes.column}>
            <MsgList handleSelect={(msg) => this.selectMessage(msg)} selectedMessage={this.state.selectedMessage} />
          </Grid>
          <Grid item xs={6} className={classes.column}>
            <MsgShow message={this.state.selectedMessage} />
          </Grid>
        </Grid>*/}
        <Route exact path="/" component={Home}/>
        <Route path="/edit" component={Edit}/>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js